import * as UnitTest from '../services/UnitTest';

export default {
  namespace: 'UnitTest',

  state: {
    getTest: null,
    editRuleManaList: null,
    deleteRuleManaList: null,
    getUnitTest: null,
  },

  effects: {
    *getTest({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(UnitTest.getTest, values);
      yield put({
        type: 'save',
        payload: {
          getTest: response,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },

    *editRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(UnitTest.editRuleManaList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editRuleManaList: response,
        },
      });
    },
    *deleteRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        UnitTest.deleteRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleManaList: response,
        },
      });
    },
    *getUnitTest({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(UnitTest.getUnitTest, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          getUnitTest: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
